/** Mobile navigation disclosure. Toggles a class on the header rather than the
 *  `hidden` attribute, so the same list can stay visible on desktop. */
const header = document.querySelector('.yc-header');
const toggle = header?.querySelector('.yc-header__toggle');

if (header && toggle) {
  toggle.addEventListener('click', () => {
    const open = header.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
    if (!event.matches) return;
    header.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  });
}
